import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { finalize } from 'rxjs/operators';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as _ from 'lodash';
import { PopupService } from '../../../services/popup/popup.service';
import { Popup } from '../../../../model/class/Popup';
import { IPopup } from '../../../../model/interface/IPopup';
import { FileUploader } from 'ng2-file-upload';
import { APP_CONTS } from '../../../app.constants';
import { ImageResizeService } from './../../../services/image-resize.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditPopupComponent } from '../edit-popup/edit-popup.component';

const TYPE_SLIDE = 'SLIDE';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  providers: [DragulaService],
})
export class PopupComponent implements OnInit {

  activos: Popup[] = [];
  inactivos: Popup[] = [];
  eliminados: Popup[] = [];

  contIdsNuevos = -1;

  loaders = {
    image: false,
    form: false,
    edit: false
  };
  page = 1;
  pageSize = 18;

  public uploader: FileUploader = new FileUploader({
    allowedMimeType: APP_CONTS.FILES.IMAGE_FORMAT
  });

  constructor(
    private dragulaService: DragulaService,
    private toasts: ToastsManager,
    private popupService: PopupService,
    private imageResizeService: ImageResizeService,
    private modalService: NgbModal,
  ) {
    dragulaService.setOptions('bag-popup', {
    });

    dragulaService.dropModel.subscribe((value) => {
      this.onDropModel(value.slice(1));
    });
    dragulaService.removeModel.subscribe((value) => {
      this.onRemoveModel(value.slice(1));
    });
  }

  private onDropModel(args) {
    let [el, target, source] = args;
    // do something else
  }

  private onRemoveModel(args) {
    let [el, source] = args;
    // do something else
  }

  ngOnInit() {
    this.popupService.all()
      .subscribe((resp) => {
        _.each(resp.data, (popup: IPopup) => {
          if (popup.activo === 'ACTIVO') {
            this.activos.push(new Popup(popup));
          } else {
            this.inactivos.push(new Popup(popup));
          }
        });
      });
  }

  crearNuevo() {
    if (this.uploader.queue[this.uploader.queue.length - 1]) {
      const file = this.uploader.queue[this.uploader.queue.length - 1]._file;
      if (file) {
        this.loaders.image = true;
        const newPopup = new Popup({
          id: this.contIdsNuevos,
          activo: 'INACTIVO',
          esNuevo: true,
          imagen: '',
          nuevaImagen: file,
          fechaInicio: new Date().toISOString().substring(0, 10),
          horaInicio: new Date().toLocaleTimeString('en-US', { hour12: false }).substring(0, 5),
          fechaFin: new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().substring(0, 10),
          horaFin: new Date(new Date().getTime() + 60 * 60 * 1000).toLocaleTimeString('en-US', { hour12: false }).substring(0, 5),
          modificado: false,
        });

        let name = file.name.replace(/\_/g, ' ');
        name = name.replace(/-/g, ' ');
        name = name.substring(0, name.lastIndexOf('.'));

        this.imageResizeService.resize([file], 1024, 768)
          .subscribe((result) => {
            const reader = new FileReader();
            reader.onload = (e: any) => {
              newPopup.imagen = e.target.result;
            };
            reader.readAsDataURL(result);

            this.loaders.image = false;
            const viewModal = this.modalService.open(EditPopupComponent, { size: 'lg', windowClass: 'modal-admin' });
            viewModal.componentInstance.newPopup = newPopup;
            this.loaders.edit = true;

            viewModal.result
              .then((createPopup: Popup) => {
                this.loaders.edit = false;
                this.contIdsNuevos--;
                createPopup.esNuevo = true;

                if (createPopup.activo === 'ACTIVO') {
                  this.activos.push(createPopup);
                } else {
                  this.inactivos.push(createPopup);
                }
              }, (reason) => {
                this.loaders.edit = false;
              });

          });
      }
    } else {
      console.log('Archivo no valido');
    }
  }

  guardarCambios() {
    this.loaders.form = true;
    const obsEliminar = [];
    const obsCrear = [];
    const obsModificar = [];

    let errorEliminar = [];
    let errorCrear = [];
    let errorModificar = [];

    const nuevosFinal = _.union(_.filter(this.activos, { 'esNuevo': true }), _.filter(this.inactivos, { 'esNuevo': true }));

    const modActivos = _.filter(this.activos, (o: Popup) => {
      if (!o.esNuevo && o.modificado) {
        return o;
      }
    });
    const modInactivos = _.filter(this.inactivos, (o: Popup) => {
      if (!o.esNuevo && o.modificado) {
        return o;
      }
    });

    const modificadosFinal = _.union(modActivos, modInactivos);

    /**
     * 1. Elimino.
     */

    _.each(this.eliminados, (popup) => {
      obsEliminar.push(this.popupService.eliminar(popup.id));
    });

    /**
     * 2. Creo.
     */
    _.each(nuevosFinal, (popup: Popup) => {
      obsCrear.push(this.popupService.crear(popup.getFormData()));
    });

    /**
     * 3. Modifico
     */
    _.each(modificadosFinal, (popup: Popup) => {
      obsModificar.push(this.popupService.edit(popup.id, popup.getFormData()));
    });

    forkJoin(obsEliminar)
      .pipe(
        finalize(() => {
          forkJoin(obsCrear)
            .pipe(
              finalize(() => {
                forkJoin(obsModificar)
                  .pipe(
                    finalize(() => {
                      if (errorEliminar.length === 0 && errorCrear.length === 0 && errorModificar.length === 0) {
                        this.toasts.success('Cambios guardados');

                        this.activos = [];
                        this.inactivos = [];
                        this.popupService.all()
                          .subscribe((resp) => {
                            _.each(resp.data, (popup: IPopup) => {
                              if (popup.activo === 'ACTIVO') {
                                this.activos.push(new Popup(popup));
                              } else {
                                this.inactivos.push(new Popup(popup));
                              }
                            });
                          });


                      } else {
                        let mensaje = '<ul>';

                        if (errorEliminar.length > 0) {
                          mensaje = mensaje + '<li>Han ocurrido problemas al eliminar los Popups</li>';
                          console.error(errorEliminar);
                        }
                        if (errorCrear.length > 0) {
                          mensaje = mensaje + '<li>Han ocurrido problemas al crear los nuevos Popups</li>';
                          console.error(errorCrear);
                        }
                        if (errorModificar.length > 0) {
                          mensaje = mensaje + '<li>Han ocurrido problemas al modificar Popups</li>';
                          console.error(errorModificar);
                        }
                        mensaje = mensaje + '</ul>';

                        if (errorEliminar.length === 0 || errorCrear.length === 0 || errorModificar.length === 0) {
                          mensaje = mensaje + '<p>Las demás acciones se han realizado con éxito</p>';
                        }
                        this.toasts.warning(mensaje, 'Ups...', { enableHTML: true });
                      }

                      this.loaders.form = false;
                    }))
                  .subscribe((resp) => {
                  }, (errors) => {
                    errorModificar = errors;
                  });
              }))
            .subscribe((resp) => {
            }, (errors) => {
              errorCrear = errors;
            });
        }))
      .subscribe((resp) => {
      }, (errors) => {
        errorEliminar = errors;
      });
  }

  editar(popup: Popup, publicado: boolean) {
    const clon: Popup = _.clone(popup);
    const viewModal = this.modalService.open(EditPopupComponent, { size: 'lg', windowClass: 'modal-admin' });
    viewModal.componentInstance.popup = clon;

    this.loaders.edit = true;

    viewModal.result
      .then((newPopup: Popup) => {
        this.loaders.edit = false;
        newPopup.modificado = true;
        if (publicado) {
          const index = _.findIndex(this.activos, { 'id': newPopup.id });

          if (newPopup.activo === 'ACTIVO') {
            this.activos[index] = newPopup;
          } else {
            _.remove(this.activos, { 'id': newPopup.id });
            this.inactivos.push(newPopup);
          }
        } else {
          const index = _.findIndex(this.inactivos, { 'id': newPopup.id });

          if (newPopup.activo === 'ACTIVO') {
            _.remove(this.inactivos, { 'id': newPopup.id });
            this.activos.push(newPopup);
          } else {
            this.inactivos[index] = newPopup;
          }
        }
      }, (reason) => {
        this.loaders.edit = false;
      });
  }

  eliminar(popup: Popup) {
    if (popup.activo === 'ACTIVO') {
      _.remove(this.activos, { 'id': popup.id });
    } else {
      _.remove(this.inactivos, { 'id': popup.id });
    }

    this.eliminados.push(popup);
  }


}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/popup/popup.component.ts